import React from "react";
import ReactDOM from "react-dom";

import "./styles.scss";

import { LeftPanel } from "./pages/LeftPanel";
import { CentrePanel } from "./pages/CentrePanel";
import { RightPanel } from "./pages/RightPanel";
import { SaveOverlay } from "./pages/SaveOverlay";
import { Loading } from "./pages/Loading";
import { AboutOverlay } from "./pages/AboutOverlay";
import { LoadOverlay } from "./pages/LoadOverlay";
import { WelcomePage } from "./pages/WelcomePage";


export class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      layers: [],
      activeLayer: -1,
      saving: false,
      loading: false,
      about: false,
      welcome: false,
      state: "loading",
      collection: "apple",
      sections: [],
      screenWidth: 100,
      screenHeight: 100
    };

    this.resize = this.resize.bind(this);
    this.loadFromOverlay = this.loadFromOverlay.bind(this);
    this.loadEmojiParts = this.loadEmojiParts.bind(this);
    this.changeCollection = this.changeCollection.bind(this);

    this.addLayer = this.addLayer.bind(this);
    this.editLayer = this.editLayer.bind(this);
    this.removeLayer = this.removeLayer.bind(this);
    this.moveLayerUp = this.moveLayerUp.bind(this);
    this.moveLayerDown = this.moveLayerDown.bind(this);
    this.selectLayer = this.selectLayer.bind(this);
    this.resetLayers = this.resetLayers.bind(this);

    this.toggleSaveOverlay = this.toggleSaveOverlay.bind(this);
    this.toggleLoadOverlay = this.toggleLoadOverlay.bind(this);
    this.toggleInfoOverlay = this.toggleInfoOverlay.bind(this);
    this.openWelcomePage = this.openWelcomePage.bind(this);
    this.closeWelcomePage = this.closeWelcomePage.bind(this);

    this.startLoad = this.startLoad.bind(this);
    this.endLoad = this.endLoad.bind(this);
  }

  resize() {
    this.setState({
      screenWidth: window.innerWidth - 17,
      screenHeight: window.innerHeight - 16
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // save layers
    if(prevState.layers != this.state.layers) {
      window.localStorage.setItem("emoji-layers", JSON.stringify(this.state.layers) );
    }
  }

  componentWillMount() {
    // handle resizing
    this.resize();

    window.addEventListener("resize", this.resize, false);

    // set collection
    var coll = window.localStorage.getItem("emoji-collection");

    if(coll != undefined) {
      // load the saved one if it's available
      this.loadEmojiParts(coll);
    }
    else {
      // otherwise load apple by default
      this.loadEmojiParts("apple");
    }

    // set layers
    var layers = window.localStorage.getItem("emoji-layers");

    if(layers != undefined && layers != "undefined") {
      // welcome screen or nah
      var welcome = false,
        layersObj = JSON.parse(layers);

      if(layersObj.length == 0 || layersObj == []) {
        welcome = true;
      }

      this.setState({ layers: layersObj, welcome: welcome });
    }
    else {
      this.setState({ layers: [], welcome: true });
    }
  }


  loadFromOverlay(data) {
    // load from overlay
    this.setState({
      loading: false,
      layers: data
    });
  }

  loadEmojiParts(collection) {
    // load set of parts from a .JSON file

    this.setState({ state: "loading" });


    fetch("./data/" + collection + ".json")
    .then((response) => {
      // check the response got here ok
      if(!response.ok) {
        this.setState({ state: "idle" });

        throw new Error("HTTP Error" + response.details);
      }
      
      return response.json();
    })
    .then((json) => {
      // get the JSON stuff
      console.log("Loaded collection: " + json.name);

      this.setState({
        collection: json.code,
        heads: json.heads,
        eyes: json.eyes,
        mouths: json.mouths,
        accessories: json.accessories,
        sections: json.sections,
        state: "idle"
      });
    })
    .catch((err) => {
      console.error(err);
      this.setState({ state: "idle" });
    })

  }

  changeCollection(e) {
    window.localStorage.setItem("emoji-collection", e.target.value);
    this.loadEmojiParts(e.target.value);
  }


  addLayer(section, icon) {
    var tmp = this.state.layers;

    // calc hflip; auto flip for other eye
    var hflip = false, leftCount = 0, rightCount = 0;

    for(var i = 0; i < this.state.layers.length; i++) {
      // see how many flipped vs unflipped eyes there are
      if(this.state.layers[i].section == "eyes") {
        if(this.state.layers[i].hFlip) {
          rightCount++;
        }
        else {
          leftCount++;
        }
      }
    }

      // flip/unflip new eye accordingly
    if(leftCount > rightCount && section == "eyes") {
      hflip = true;
    }


    tmp.unshift({
      section: section,
      collection: this.state.collection,
      item: icon,
      hFlip: hflip,
      xOffset: 0,
      yOffset: 0,
      rotation: 0,
      scale: 1,
      hidden: false
    });

    this.setState({ layers: tmp, activeLayer: 0 });
  }

  editLayer(index, attribute, value) {
    var tmp = this.state.layers;

    tmp[index][attribute] = value;

    this.setState({ layers: tmp });
  }

  removeLayer(index) {
    var tmp = this.state.layers;

    tmp.splice(index, 1);

    this.setState({layers: tmp, activeLayer: -1});
  }
  
  moveLayerUp(index) {
    var tmp = this.state.layers,
      oldIndex = index - 1;

    if(oldIndex < 0) {
      oldIndex = this.state.layers.length - 1;
    }

    var old = tmp[oldIndex];
    tmp[oldIndex] = tmp[index];
    tmp[index] = old;

    this.setState({
      layers: tmp, 
      activeLayer: -1
    });
  }
  
  moveLayerDown(index) {
    var tmp = this.state.layers,
      oldIndex = index + 1;

    if(oldIndex > this.state.layers.length-1) {
      oldIndex = 0;
    }

    var old = tmp[oldIndex];
    tmp[oldIndex] = tmp[index];
    tmp[index] = old;

    this.setState({
      layers: tmp, 
      activeLayer: -1 
    });
  }

  selectLayer(index) {
    var tmp = index;

    if(index == this.state.activeLayer) {
      tmp = -1;
    }

    this.setState({ activeLayer: tmp });
  }

  resetLayers() {
    this.setState({ activeLayer: -1, layers: [] });
  }


  toggleSaveOverlay() {
    this.setState({ saving: !this.state.saving });
  }

  toggleInfoOverlay() {
    this.setState({ about: !this.state.about });
  }

  toggleLoadOverlay() {
    this.setState({ loading: !this.state.loading });
  }

  openWelcomePage() {
    this.setState({ welcome: true });
  }

  closeWelcomePage(openLoad) {
    // decide how to start
    if(openLoad) {
      // load from saved emotes
      this.setState({
        welcome: false,
        loading: true
      });
    }
    else {
      // new; blank
      this.setState({
        welcome: false,
        layers: [],
        loading: false
      });
    }
  }


  startLoad() {
    this.setState({ state: "loading" });
  }

  endLoad() {
    this.setState({ state: "idle" });
  }


  render() {
    return (
      <div className="App" id="App2" style={{width: this.state.screenWidth, height: this.state.screenHeight}}>
        <WelcomePage open={this.state.welcome} dismiss={this.closeWelcomePage} />

        <Loading open={(this.state.state == "loading")} />

        <AboutOverlay open={this.state.about} toggle={this.toggleInfoOverlay} />

        <LoadOverlay open={this.state.loading} toggle={this.toggleLoadOverlay} select={this.selectLayer} load={this.loadFromOverlay} />

        <SaveOverlay 
          open={this.state.saving} 
          toggle={this.toggleSaveOverlay} 
          layers={this.state.layers} 
          loadStart={this.startLoad}
          loadEnd={this.endLoad}
        />


        <LeftPanel 
          add={this.addLayer} 
          clear={this.resetLayers} 
          collection={this.state.collection} 
          changeCollection={this.changeCollection}
          emoji={this.state.sections}
        />

        <CentrePanel 
          layers={this.state.layers}
          active={this.state.activeLayer}
          select={this.selectLayer}
          edit={this.editLayer}
          save={this.toggleSaveOverlay}
          about={this.toggleInfoOverlay}
          new={this.openWelcomePage}
          loadOpen={this.toggleLoadOverlay}
          loadStart={this.startLoad}
          loadEnd={this.endLoad}
        />

        <RightPanel 
          layers={this.state.layers} 
          active={this.state.activeLayer}
          remove={this.removeLayer} 
          up={this.moveLayerUp}
          down={this.moveLayerDown}
          edit={this.editLayer}
          select={this.selectLayer}
          reset={this.resetLayers}
        />
      </div>
    );
  }
}


const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
